import ContainerAvailabilityForecast from './ContainerAvailabilityForecast'
import DryStorage from './DryStorage'
import TruckCapacity from './TruckCapacity'
import OptimalProcessedContainersByProduct from './OptimalProcessedContainersByProduct'

const Monitoring = ({
    id,
}: {
    id: number
}) => {
    return (
        <>
            <ContainerAvailabilityForecast id={id} />
            <OptimalProcessedContainersByProduct id={id} />
            <DryStorage id={id} />
            <TruckCapacity id={id} />
        </>
    )
}

export default Monitoring
